import { render } from "./HomeView.vue?vue&type=template&id=8bf47bc8"
const script = {}

import exportComponent from "/var/www/ep/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__